import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const ThumbsUpDown = ({title, primaryClassName, secondaryClassName, tertiaryClassName, className}: SVGProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        {title && <title>{title}</title>}
        <path className={primaryClassName} d="M19 12.31L22.54 7H25.84l.87-2h-5.25L17 11.7V17h2v-4.69z" />
        <path className={secondaryClassName} d="M24.53 10l1.31-3h-2.18l-2.19 5H28v4.73A2.28 2.28 0 0 1 25.66 19H22v2h3.66A4.26 4.26 0 0 0 30 16.74V10z" />
        <path className={tertiaryClassName} d="M17 19h5v2h-5z" />
        <path
            className={primaryClassName}
            d="M13 19.69L9.46 25H8.34l2.19-5H4v-4.74A2.28 2.28 0 0 1 6.34 13H15v-2H6.34A4.26 4.26 0 0 0 2 15.26V22h5.47l-2.18 5h5.25L15 20.3V15h-2z"
        />
    </svg>
);

export default ThumbsUpDown;
